import React from "react";
import { useDispatch, useSelector } from 'react-redux';
import { getAll } from "../../api/breakAPI";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../Loader";

function Breaks() {
    // STATE ===============================================================================
    const dispatch = useDispatch();
    const breaks = useSelector((state) => state.breaks.breaks)
    const token = useSelector(state => state.user.token)
    const userID = useSelector(state => state.user.user._id)
    const loading = useSelector(state => state.breaks.loading)
    const navigate = useNavigate();

    // GET ===============================================================================
    React.useEffect(() => {
        dispatch(getAll({token, userID}))
    }, [dispatch, token, userID])

    // DOM RENDER ===============================================================================
    return(
        <div className="content">
            <h1>My Breaks</h1>

            <Link to="new" className="mb-5 btn-primary block w-48 mx-auto">Create a New Break</Link>

            <p className="description mb-6">Note: If any of your data is not loading, try signing in again as your session may have expired.</p>

            {!loading ? <div className="m-5 flex flex-row flex-wrap justify-center align-center">
                {breaks.map(item => {
                    return (
                        <div key={item._id} className="border rounded-xl m-5 pb-3 zoom bg-white shadow-md w-3/12 mobile-w-10-12" onClick={() => navigate(item._id)}>
                            <h3 className="p-3 bg-gray-100 rounded-t-xl font-bold">{item.name}</h3>
                            <h4 className="underline my-3">Buoys</h4>
                            {item.buoys.map(buoy => {
                                return <p key={buoy.id} className="p-2 rounded-b">{buoy.id} - {buoy.name}</p>
                            })}
                        </div>
                    )
                })}
            </div> : <Loader />}

        </div>
    )
}

export default Breaks;